<template>
    <div>
      <div class="mb-8 flex justify-start max-w-3xl">
        <h1 class="font-bold text-3xl">
          <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('orderapplications')">Regresar</inertia-link>
          <span class="text-indigo-400 font-medium">/</span>
          Generar Solicitud
        </h1>
       
      </div>
    <form @submit.prevent="storeSolicitud">
          <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
              <tr class="text-left font-bold">
                <th class="px-4 pt-6 pb-4">Seleccionar</th>
                <th class="px-6 pt-6 pb-4">Cantidad</th>
                <th class="px-6 pt-6 pb-4">Material</th>   
                <th class="px-6 pt-6 pb-4">Precio</th>
                <th class="px-6 pt-6 pb-4">IVA</th>
                <th class="px-6 pt-6 pb-4">Subtotal</th>
                <th class="px-6 pt-6 pb-4" colspan="2">Detalle</th>
              </tr>
              <tr v-for="applicationbuy in applicationsdeatil" :key="applicationbuy.id" class="hover:bg-gray-100 focus-within:bg-gray-100  items-center">
                <td class="border-t px-6 py-4">
                  <input type="checkbox" class="px-6 py-4 items-center" label="50" :id="applicationbuy.id" :value="applicationbuy.id" v-model="form2.checkedNames" />
                </td>
                <td class="border-t px-6 py-4">
                    {{ applicationbuy.amount }}
                </td>
               
                <td class="border-t px-6 py-4">
                    {{ applicationbuy.name }}
                </td>
                <td class="border-t">
                  {{  applicationbuy.cost }}   
                </td>
                <td class="border-t">
                  {{  applicationbuy.iva }}   %
                </td>
                <td class="border-t">
                  {{  applicationbuy.total }}   
                </td>
                
                <td class="border-t">
                    {{ applicationbuy.detail }}
                </td>
              
              </tr>
            </table>
          </div>
  
      <pagination class="mt-6" :links="applicationsdeatil.links" />
      <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
            <loading-button :loading="form2.processing" class="btn-indigo" type="submit">Generar</loading-button>
          </div>
    </form>
    </div>
    
  </template>
  
  <script>
  import Icon from '@/Shared/Icon'
  import pickBy from 'lodash/pickBy'
  import Layout from '@/Shared/LayoutMenu'
  import throttle from 'lodash/throttle'
  import mapValues from 'lodash/mapValues'
  import Pagination from '@/Shared/Pagination'
  import SearchFilter from '@/Shared/SearchFilter'
  import LoadingButton from '@/Shared/LoadingButton'
  
  export default {
    metaInfo: { title: 'ApplicationsBuy' },
    components: {
      Icon,
      Pagination,
      SearchFilter,
      LoadingButton,
    },
    layout: Layout,
    props: {
      filters: Object,
      applicationsdeatil: Array,
      application: Object,
      contact: Array
    },
    data() {
      return {
        form: {
          search: this.filters.search,
          trashed: this.filters.trashed,
        },
        form2: this.$inertia.form({
         checkedNames:  [],
        }),
      }
    },
    watch: {
      form: {
        deep: true,
        handler: throttle(function() {
          this.$inertia.get(this.route('applicationbuy.createPagos'), pickBy(this.form), { preserveState: true })
        }, 150),
      },
    },
    methods: {
      reset() {
        this.form = mapValues(this.form, () => null)
      },
      storeSolicitud() {
        
        this.form2.post('/orderapplicationbuygestion')
      },
    },
  }
  </script>
  